module.exports = __webpack_public_path__ + "static/media/zip.b70e4ecd.svg";